import React, { JSX } from "react";
import { Navigate } from "react-router-dom";

// eslint-disable-next-line react-refresh/only-export-components
export const getIsAuthed = () => {
  const expiresInString = localStorage.getItem("expires_in");
  if (!expiresInString) {
    return false;
  }

  const expiresAt = JSON.parse(expiresInString);

  return new Date().getTime() < expiresAt;
};

const RequireAuth: React.FC<
  { redirectTo?: string } & JSX.IntrinsicElements["div"]
> = ({ redirectTo, children }) => {
  const isAuthed = getIsAuthed();
  const redirect = redirectTo ? redirectTo : "/login";

  return isAuthed ? <>{children}</> : <Navigate to={redirect} />;
};

export default RequireAuth;
